import React from 'react';
import './MScInAccountingAndFinance.css'; // Optional: Create a CSS file for styling

const BAInEconomics = () => {
  return (
    <div className="msc-container" style={{ padding: '20px', maxWidth: '800px', marginTop: '160px',marginLeft:'70px' }}>
      <h1 style={{ textAlign: 'center' }}>
        📘 Bachelor of Arts in Economics
      </h1>

      <section>
        <h2 style={{ textAlign: 'center' }}>Program Overview</h2>
        <p>
          The BA in Economics at Admas University is designed to provide students with strong analytical, quantitative, and policy-based skills to understand economic issues and contribute to national development. This program focuses on equipping students with a deep understanding of microeconomics, macroeconomics, development economics, and econometrics.
        </p>
      </section>

      <section>
        <h2>🎓 Program Objectives</h2>
        <ul>
          <li>To provide a solid foundation in economic theory, policy, and analysis.</li>
          <li>To equip students with practical tools for analyzing economic and development challenges.</li>
          <li>To prepare students for careers in government, finance, research, and international development.</li>
          <li>To cultivate critical thinking and decision-making skills in economic planning and strategy.</li>
        </ul>
      </section>

      <section>
        <h2>📚 Key Courses</h2>
        <ul>
          <li>Microeconomics</li>
          <li>Macroeconomics</li>
          <li>Mathematics for Economists</li>
          <li>Public Finance</li>
          <li>Development Economics</li>
          <li>International Economics</li>
          <li>Econometrics</li>
          <li>Environmental Economics</li>
          <li>Project Planning and Analysis</li>
          <li>Research Methods & Senior Thesis</li>
        </ul>
      </section>

      <section>
        <h2>🎓 Admission Requirements</h2>
        <ul>
          <li>Successful completion of Grade 12 with a passing score on the Ethiopian university entrance exam.</li>
          <li>Diploma holders in related fields may enter through an advanced standing scheme.</li>
        </ul>
      </section>

      <section>
        <h2>🧭 Career Opportunities</h2>
        <p>
          Graduates can pursue careers in economic research, public policy, banking, international organizations, consulting, and development agencies. The degree also provides a strong foundation for further studies at the graduate level.
        </p>
      </section>

      <section>
        <h2>🏛️ Why Study Economics at Admas University?</h2>
        <ul>
          <li>Nationally accredited and widely respected undergraduate program.</li>
          <li>Experienced academic staff with strong research backgrounds.</li>
          <li>Opportunities for internships and practical research experience.</li>
          <li>Flexible learning modes across multiple campuses and distance education centers.</li>
        </ul>
      </section>
    </div>
  );
};

export default BAInEconomics;